module.exports = flarum.core.compat['components/AppearancePage'];